import React from 'react';
import { Badge } from './ui/badge';
import { ShieldCheck, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';

export const Hero = () => {
  return (
    <section id="top" className="relative presidential-gradient overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-8 items-center pt-12 lg:pt-20 pb-12 lg:pb-16">
        {/* Left Content */}
        <motion.div
          className="lg:col-span-6 flex flex-col gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex flex-wrap items-center gap-3">
            <Badge
              data-testid="veteran-badge"
              className="bg-slate-800/50 border border-slate-400/50 text-slate-300 flex items-center gap-1.5 px-3 py-1.5"
            >
              <ShieldCheck className="h-4 w-4" />
              Veteran-Owned
            </Badge>
            <Badge
              data-testid="service-area-badge"
              className="bg-slate-800/50 border border-slate-400/50 text-slate-300 flex items-center gap-1.5 px-3 py-1.5"
            >
              <MapPin className="h-4 w-4" />
              Northeast Ohio
            </Badge>
            {/* Thumbtack Reviews Widget */}
            <a
              href="https://www.thumbtack.com/oh/akron/appliance-repair/remodworks/service/472485277093888025"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="thumbtack-reviews-badge"
              className="flex items-center gap-2 bg-slate-800/50 border border-slate-400/50 rounded-full px-3 py-1.5 hover:bg-slate-700/50 transition-colors duration-200"
            >
              <img 
                src="https://cdn.thumbtackstatic.com/fe-assets-web/media/logos/thumbtack/wordmark.svg" 
                alt="Thumbtack" 
                className="h-4 brightness-0 invert opacity-80"
              />
              <div className="flex items-center gap-0.5">
                <img src="https://cdn.thumbtackstatic.com/fe-assets-web/media/pages/profile/standard-widgets/review-widget/orange_star.svg" alt="" className="h-3.5 w-3.5" />
                <img src="https://cdn.thumbtackstatic.com/fe-assets-web/media/pages/profile/standard-widgets/review-widget/orange_star.svg" alt="" className="h-3.5 w-3.5" />
                <img src="https://cdn.thumbtackstatic.com/fe-assets-web/media/pages/profile/standard-widgets/review-widget/orange_star.svg" alt="" className="h-3.5 w-3.5" />
                <img src="https://cdn.thumbtackstatic.com/fe-assets-web/media/pages/profile/standard-widgets/review-widget/orange_star.svg" alt="" className="h-3.5 w-3.5" />
                <img src="https://cdn.thumbtackstatic.com/fe-assets-web/media/pages/profile/standard-widgets/review-widget/orange_star.svg" alt="" className="h-3.5 w-3.5" />
              </div>
              <span className="text-xs font-medium text-slate-300">403 reviews</span>
            </a>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-white leading-tight tracking-tight">
            Expert Home Repair Services You Can Trust
          </h1>

          <p className="text-lg sm:text-xl lg:text-2xl text-slate-300 leading-relaxed max-w-prose font-medium">
            We specialize in appliance repair and sell quality refurbished appliances. For plumbing, electrical, handyman services, and carpentry, we partner with trusted, vetted, insured, and bonded contractors we personally vouch for—so you never have to risk hiring the wrong person.
          </p>

        </motion.div>

        {/* Right Image */}
        <motion.div
          className="lg:col-span-6 relative h-72 sm:h-96 lg:h-[500px]"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <img
            data-testid="hero-image"
            src="https://customer-assets.emergentagent.com/job_e79e39c4-7750-4b61-b714-01635a368d6f/artifacts/a2arwqih_69c90d5e-14e8-4a15-b5da-3ae0aacd404a.png"
            alt="Professional technician explaining home inspection to customer"
            loading="eager"
            className="absolute inset-0 w-full h-full object-cover rounded-xl border border-slate-700 shadow-lg"
          />
        </motion.div>
      </div>
    </section>
  );
};